import { render, staticRenderFns } from "./sign-record.vue?vue&type=template&id=31ff7f76&scoped=true&"
import script from "./sign-record.vue?vue&type=script&lang=ts&"
export * from "./sign-record.vue?vue&type=script&lang=ts&"
import style0 from "./sign-record.vue?vue&type=style&index=0&id=31ff7f76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff7f76",
  null
  
)

export default component.exports